var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(0 0.25)",
    fill: "#1F1F26"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 0.25,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#303030"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 7.86662C6 7.48182 6.13514 7.16436 6.40541 6.91424C6.67567 6.66412 7.02703 6.53906 7.45946 6.53906C7.88417 6.53906 8.2278 6.66219 8.49035 6.90847C8.76061 7.16244 8.89575 7.49336 8.89575 7.90126C8.89575 8.27066 8.76448 8.5785 8.50193 8.82478C8.23166 9.07874 7.87645 9.20573 7.43629 9.20573H7.42471C7 9.20573 6.65637 9.07874 6.39382 8.82478C6.13127 8.57081 6 8.25142 6 7.86662ZM6.15058 17.9676V10.2562H8.72201V17.9676H6.15058ZM10.1467 17.9676H12.7181V13.6617C12.7181 13.3923 12.749 13.1846 12.8108 13.0383C12.9189 12.7767 13.083 12.5554 13.3031 12.3746C13.5232 12.1937 13.7992 12.1033 14.1313 12.1033C14.9961 12.1033 15.4286 12.6843 15.4286 13.8464V17.9676H18V13.5463C18 12.4073 17.7297 11.5434 17.1892 10.9546C16.6486 10.3659 15.9344 10.0715 15.0463 10.0715C14.0502 10.0715 13.2741 10.4987 12.7181 11.3529V11.376H12.7066L12.7181 11.3529V10.2562H10.1467C10.1622 10.5025 10.1699 11.2682 10.1699 12.5535C10.1699 13.8387 10.1622 15.6434 10.1467 17.9676Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.3318f2bb1e776009122f6a83e02978f5.svg";
export { ForwardRef as ReactComponent };